import { Flex } from '@chakra-ui/react';
import React from 'react';
import { format } from 'date-fns';
import { DateRange, DynamicDateRange } from '../../../components/DateRangeSelector/DynamicDateRange';
import { API_DATE_PATTERN } from '../settlements.constants';
import { LAST_DAYS_DEFAULT_RANGE } from '../../home/util/GetDateRangeUtil';

export interface SettlementsFilterProps {
  start: string;
  end: string;
  onDateRangeChange: (start: string, end: string) => void;
}

export const SettlementsFilters = ({ start, end, onDateRangeChange }: SettlementsFilterProps) => {

  const handleDateRangeChange = ({ startDate, endDate }: DateRange) => {
    if (!startDate || !endDate) {
      return;
    }
    onDateRangeChange(format(startDate, API_DATE_PATTERN), format(endDate, API_DATE_PATTERN));
  };

  return (
    <Flex>
      <DynamicDateRange
        onDateRangeChange={handleDateRangeChange}
        startDate={start}
        endDate={end}
        defaultRangeDays={LAST_DAYS_DEFAULT_RANGE}
        marginX="l"
      />
    </Flex>
  );
};
